// The web half of the material preset contract (spec §A/§B). The asset manager
// owns and serves the templates; this fills one BY PARAMETER NAME, exactly as
// the server's material_presets.Fill does for the importer and the migration,
// so the three producers mint structurally identical graphs.
import { compileMaterialGraphToTSL } from './materialGraphTSL.js'

export const PRESET_PARAM_NAMES = Object.freeze([
  'Base Color', 'Base Color Tint',
  'Normal', 'Normal Strength',
  'Roughness', 'Roughness Factor',
  'Metalness', 'Metalness Factor',
  'Ambient Occlusion',
  'Emissive', 'Emissive Color',
])

export const OUT_KEY = 'out'

export function presetParamNames(template) {
  return (template?.nodes ?? [])
    .filter(n => n.data?.param && n.data.paramName)
    .map(n => n.data.paramName)
}

export function fillPreset(template, values = {}) {
  const g = structuredClone(template)
  const byParam = new Map()
  let out = null
  for (const n of g.nodes ?? []) {
    if (n.id === OUT_KEY) out = n
    if (n.data?.param && n.data.paramName) byParam.set(n.data.paramName, n)
  }
  if (!out) throw new Error('preset has no output node')
  for (const [key, val] of Object.entries(values)) {
    if (key === OUT_KEY) { out.data = { ...(out.data ?? {}), ...val }; continue }
    const n = byParam.get(key)
    if (!n) throw new Error(`unknown preset parameter "${key}"`)
    if (val && 'textureId' in val) n.data.textureId = val.textureId
    if (val && 'value' in val) n.data.value = val.value
  }
  return g
}

// A served template is data from another repo: compile it before creating a
// row from it, so a node rename or a bad handle is an error dialog naming the
// problem rather than a material that reports `unresolved` on the avatar.
//
// THROUGH THE COMPILER THAT ACTUALLY RENDERS. This used to validate with the
// GLSL compiler, which stopped drawing anything the moment the app moved to
// `WebGPURenderer` — so it could pass a template the renderer then refuses, and
// the author would get the neutral placeholder with nothing saying why. One
// compiler means the question "does this compile" has one answer.
export function assertPresetCompiles(template) {
  const c = compileMaterialGraphToTSL(template)
  if (c.errors.length) throw new Error(`material preset does not compile: ${c.errors.join('; ')}`)
  return c
}
